import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import { ButtonsRow, ErrorSpan, FormContentWrapper } from './styles';
import { SelectDays } from './components/SelectDay';
import { SelectPermission } from './components/SelectPermission';
import { useFormContext, useFormState } from 'react-hook-form';
import { DamScheduleFormValues } from './types';
import { ControlledInput } from './components/Input';
import { DATE_MASK } from '~/helpers/maskInputs';
import { TimeRow } from './components/TimeRow';

interface FormContentProps {
  isEdit: boolean;
  type: 'schedule' | 'exception';
  onCancel: () => void;
}

export function FormContent({
  isEdit,
  type,
  onCancel,
}: Readonly<FormContentProps>): ReactElement {
  const { control } = useFormContext<DamScheduleFormValues>();
  const { errors } = useFormState({
    control,
    name: 'weekDays',
  });
  const { t } = useTranslation();

  return (
    <FormContentWrapper>
      {type === 'exception' && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            flex: 1,
            marginBottom: '16px',
          }}
        >
          <ControlledInput
            name="exceptionDate"
            placeholder={t('dia')}
            label={t('dia')}
            mask={DATE_MASK}
            style={{
              width: '212px',
            }}
            rules={{
              required: t('dataObrigatoria'),
            }}
          />
        </div>
      )}
      <TimeRow />
      {type === 'schedule' && (<h4 style={{ fontWeight: 'bold' }}>{t('selecioneDias')}</h4>)}
      <div style={{ display: 'flex' }}>
        {type === 'schedule' && (<SelectDays />)}
      </div>
      {errors.weekDays && <ErrorSpan>{errors.weekDays.message}</ErrorSpan>}
      <h4 style={{
        fontWeight: 'bold',
        marginTop: type === 'schedule' ? 20 : undefined,
      }}
      >
        {t('funcionamento')}
      </h4>
      <SelectPermission />
      <ButtonsRow>
        <Button variant="secondary" type="button" onClick={onCancel}>
          {t('botaoVoltar')}
        </Button>
        <Button variant="primary" type="submit">
          {t(isEdit ? 'botaoEditar' : 'botaoAdicionar')}
        </Button>
      </ButtonsRow>
    </FormContentWrapper>
  );
}
